export const environment = {
  baseUrl: 'https://dgl-web-stg.th-service.co.in',
  nextApiBaseUrl: 'https://api-stg.newnext.krungthai.com',
  dglApiBaseUrl: 'https://dgl-api-stg.th-service.co.in',
  production: false,
  mode: 'stage',
  version: 'stg1.0.39',
};
